<p-tabView [(activeIndex)]="this.healthPassportData.tabview_Data.selected_tab">
  <div *ngIf="this.healthPassportData.tabview_Data.selected_tab == 0">
    <label for="patient" style="margin: 2px; margin-right: 80px; vertical-align: super">
      <b>Choose a Patient : </b></label>
    <p-dropdown id="patient" class="notranslate" [(ngModel)]="selectMemeber" placeholder="Select" optionLabel="label"
      [options]="members_list" (ngModelChange)="onChange()" [disabled]="posting"></p-dropdown>
  </div>

  <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Package Form" leftIcon="pi pi-pencil">
    <div class="ui-g-12">
      <ng-container *ngIf="selectMemeber != null && is_changing == false && !posting">
        <ng-container *ngIf="members_data">
          <ng-container style="margin-bottom: 20px">
            <div class="ui-g head1">
              <p class="head mb-3 bold-text">Health Passport</p>
            </div>
            <div class="ui-g">
              <div class="ui-g-12 ui-md-1 ui-lg-1"></div>
              <div class="ui-g-12 ui-md-3 ui-lg-3 text-center" style="padding-top: 10px">
                <img [src]="
                    members_data.user_profile_pic == null ||
                    (members_data.user_profile_pic != null &&
                      members_data.user_profile_pic.length == 0)
                      ? './assets/images/test_profile.png'
                      : members_data.user_profile_pic
                  " class="avatar-image" />
              </div>
              <div class="ui-g-12 ui-md-5 ui-lg-4 text-left">
                <!-- < class="justify-content-center text-left"> -->
                <p class="bold-text" style="
                    color: #004aad;
                    font: normal normal medium 20px/24px Montserrat;
                    margin-bottom: 10px;
                    font-weight: bolder;
                  ">
                  <span>
                    <span class="notranslate">{{ members_data.member | titlecase }}</span>,
                    {{ members_data.gender | titlecase }},
                    {{ members_data.age | titlecase }}</span>
                </p>
                <div>
                  <p class="bold-text" style="color: #004aad; margin-bottom: 10px">
                    Unique Identification: <span> </span>
                    <a (click)="showviewall()" style="cursor: pointer">{{ members_data.user_identification_type |
                      titlecase }}
                      <i class="pi pi-file"></i>
                    </a>
                  </p>
                </div>
                <div>
                  <p class="bold-text" style="
                      font: normal normal medium 20px/24px Montserrat;
                      margin-bottom: 10px;
                    ">
                    <b>MRN: {{ this.members_data.medical_record_number }}</b>
                  </p>
                </div>
              </div>
              <div class="ui-g-12 ui-md-2 ui-lg-3 text-align-right">
                <div>
                  <p class="left-float">
                    <button pButton type="button" label="Edit Profile" class="btn-white-passport"
                      [routerLink]="['/', this.slug, 'patient', 'edit-data']"></button>
                    <button pButton type="button" icon="pi pi-external-link"
                      [routerLink]="['/', this.slug, 'patient', 'activatedmembers']" label="ID Card"
                      class="btn-white-passport"></button>
                  </p>
                  <p class="left-float">
                    <button pButton type="button" label="Upload Documents"
                      [routerLink]="['/', this.slug, 'patient', 'uploadandeditdocuments']"
                      style="margin-top: 18px; width: auto; border-radius: 5px"></button>
                  </p>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- <div class="ui-g-12"></div> -->

          <div class="ui-g-12 ui-md-10 ui-lg-10 pg_bar">
            <ng-container>
              <div class="ui-g">
                <div class="ui-g-4">
                  <p class="bold-text">
                    <b>Storage:
                      {{ this.health_passport_data.formattedStorageSpaceUsed }}
                      used of
                      {{
                      this.health_passport_data.formattedMaxStorageSpace
                      }}</b>
                  </p>
                </div>
                <div class="ui-g-3"></div>
                <div class="ui-g-5" style="justify-content: end">
                  <p class="bold-text" *ngIf="
                      this.health_passport_data.valid_till != null;
                      else second
                    ">
                    <b>Validity: {{ this.health_passport_data.valid_till }}
                      <span style="color: #0580c7">( {{ this.health_passport_data.days_left }} Days left
                        for expiry.)</span></b>
                  </p>
                  <ng-template #second>
                    <p>
                      <b>Upgrade to storage worth 5 GB </b><span><button pButton pRipple style="border-radius: 5px"
                          type="button" label="Buy" (click)="this.nextTab()"></button></span>
                    </p>
                  </ng-template>
                </div>
              </div>
              <div class="ui-g-12">
                <p-progressBar [value]="this.health_passport_data.percentage" class="custom-progress-bar"
                  [style]="{ 'background-color': '#dcdcdc' }"></p-progressBar>
              </div>
            </ng-container>
          </div>

          <!-- <div *ngIf="this.health_passport_data.valid_till == null">
                        <div class="ui-g-12">
                            <div class="ui-g-12 ui-md-6 ui-lg-3">
                                <p-card header="{{this.health_passport_priority_data.consultation_name}}"
                                    subheader="{{this.health_passport_amount}}"
                                    styleClass="p-card-shadow card-border-passport">
                                    <p style="text-align: left;white-space: pre-line">
                                        {{this.health_passport_priority_data.description}}</p>
                                    <div class="p-p-3" style="margin-top:4%">
                                        <button pButton pRipple type="button" label="Buy" (click)="this.nextTab()">
                                        </button>
                                    </div>
                                </p-card>
                            </div>
                        </div>
                    </div> -->

          <p-dialog *ngIf="display" header="Unique Identification" [resizable]="false" responsive="true"
            [(visible)]="display">
            <div class="ui-g-12" style="display: table">
              <div class="text text-center" style="display: table-cell">
                <img class="circle-icon" style="height: 200px; width: 440px" [src]="
                    members_data.user_identification_pic == null ||
                    (members_data.user_identification_pic != null &&
                      members_data.user_identification_pic.length == 0)
                      ? './assets/images/aboutUs1.png'
                      : members_data.user_identification_pic
                  " />
              </div>
            </div>
          </p-dialog>
        </ng-container>

        <ng-container *ngFor="let ert of textarea">
          <ng-container *ngIf="ert.id_guid == this.member">
            <div class="ui-g-12">
              <p-fieldset [style]="{ border: '1px solid #000000' }">
                <p-header class="egd-heading heading3">Current Medical Problems</p-header>
                <textarea pInputTextarea disabled name="current_medical"
                  class="WordWrap format-lines textarea-input textarea-box-input"
                  id="current_medical">{{ ert.condition_description }}</textarea>
              </p-fieldset>
            </div>
            <div class="ui-g-12">
              <p-fieldset [style]="{ border: '1px solid #000000' }">
                <p-header class="egd-heading heading3">Past Medical History</p-header>
                <textarea pInputTextarea disabled name="pastmedic "
                  class="WordWrap format-lines textarea-input textarea-box-input"
                  id="pastmedic ">{{ ert.past_medical_history }}</textarea>
              </p-fieldset>
            </div>
            <div class="ui-g-12">
              <p-fieldset [style]="{ border: '1px solid #000000' }">
                <p-header class="egd-heading heading3">Past Surgical History</p-header>
                <textarea pInputTextarea disabled name="pastmedic "
                  class="WordWrap format-lines textarea-input textarea-box-input"
                  id="pastmedic ">{{ ert.past_surgical_history }}</textarea>
              </p-fieldset>
            </div>
            <div class="ui-g-12">
              <p-fieldset [style]="{ border: '1px solid #000000' }">
                <p-header class="egd-heading heading3">Medication</p-header>
                <textarea pInputTextarea disabled name="pastmedic "
                  class="WordWrap format-lines textarea-input textarea-box-input"
                  id="pastmedic ">{{ ert.medication }}</textarea>
              </p-fieldset>
            </div>
            <div class="ui-g-12">
              <p-fieldset [style]="{ border: '1px solid #000000' }">
                <p-header class="egd-heading heading3">Allergies</p-header>
                <textarea pInputTextarea disabled name="pastmedic "
                  class="WordWrap format-lines textarea-input textarea-box-input"
                  id="pastmedic ">{{ ert.allergy }}</textarea>
              </p-fieldset>
            </div>
            <div class="ui-g-12">
              <p-fieldset [style]="{ border: '1px solid #000000' }">
                <p-header class="egd-heading heading3">Social History</p-header>
                <textarea pInputTextarea disabled name="pastmedic "
                  class="WordWrap format-lines textarea-input textarea-box-input"
                  id="pastmedic ">{{ ert.social_history }}</textarea>
              </p-fieldset>
            </div>
            <div class="ui-g-12">
              <p-fieldset [style]="{ border: '1px solid #000000' }">
                <p-header class="egd-heading heading3">Family History</p-header>
                <textarea pInputTextarea disabled name="pastmedic "
                  class="WordWrap format-lines textarea-input textarea-box-input"
                  id="pastmedic ">{{ ert.family_history }}</textarea>
              </p-fieldset>
            </div>
            <div class="ui-g-12">
              <p-fieldset [style]="{ border: '1px solid #000000' }">
                <p-header class="egd-heading heading3">Uploaded Reports</p-header>

                <div class="ui-g" *ngIf="
                    !this.MedicalReports.data.api_result.Posting &&
                    this.MedicalReports.data.api_result.PromiseResult.success
                  ">
                  <div class="ui-g-12">
                    <h2 class="boldnlabel">Uploaded Medical Records</h2>

                    <div *ngIf="
                        this.MedicalReports.data.api_result.PromiseResult
                          ?.success != null
                      ">
                      <app-document-viewer [data]="this.MedicalReports.data.api_result">
                      </app-document-viewer>
                    </div>
                  </div>
                </div>
                <app-error-messages [api_result]="this.MedicalReports.data.api_result">
                </app-error-messages>
                <br />
              </p-fieldset>
            </div>
          </ng-container>
          <!-- <div style="text-align-last: right;">
                        <p-button type="button" [style]="{'margin-right':'5px'}" routerLink="/patient" label="Back"
                            class="p-button-lg" icon="pi pi-arrow-left"></p-button>
                    </div> -->
        </ng-container>
      </ng-container>
      <div class="row container justify-content-center text-center alert alert-danger"
        *ngIf="response?.success != null && response?.success == false">
        <p *ngIf="response?.error != null">{{ response?.error?.message }}</p>
        <div *ngIf="serverError?.error != null && serverError?.statusCode != 500">
          <p *ngFor="let message of serverError?.message">{{ message }}</p>
        </div>
        <div *ngIf="serverError?.error != null && serverError?.statusCode == 500">
          <p>{{ serverError?.message }}</p>
        </div>
      </div>
      <h4 *ngIf="posting">Fetching Your Data...</h4>
      <p-progressSpinner [style]="{ width: '50px', height: '50px' }" *ngIf="posting" strokeWidth="6">
      </p-progressSpinner>
    </div>
  </p-tabPanel>
  <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Payment" leftIcon="pi pi-pencil">
    <div class="ui-g">
      <p class="heading2 egd-theme-text">Payment</p>
      <app-payment class="ui-g-12" [payment_data]="this.healthPassportData.paymentData"
        (payment_success)="onPaymentSuccess($event)"></app-payment>
      <div class="ui-g-12 text-align-right">
        <p-button type="button" [style]="{ 'margin-right': '5px' }" (click)="prevTab()" label="Back" class="p-button-lg"
          icon="pi pi-arrow-left">
        </p-button>
      </div>
    </div>
  </p-tabPanel>
  <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Transaction Successful" leftIcon="pi pi-pencil">
    <p-dialog *ngIf="this.healthPassportData.print_data.displayModal" header="Invoice"
      [(visible)]="this.healthPassportData.print_data.displayModal" [modal]="true" [style]="{ width: '50vw' }">
      <div class="ui-g-12">
        <app-loading type="LOADING_DATA" *ngIf="this.healthPassportData.print_data.api_result.Posting">
        </app-loading>
      </div>
      <ng-container *ngIf="
          !this.healthPassportData.print_data.api_result.Posting &&
          this.healthPassportData.print_data.api_result.PromiseResult.success !=
            null &&
          this.healthPassportData.print_data.api_result.PromiseResult.success
        ">
        <div class="ui-g-12">
          <p-button icon="pi pi-check" (click)="print()" label="Print" styleClass="p-button-text">
          </p-button>
        </div>
        <div *ngIf="
            this.healthPassportData.print_data.api_result.PromiseResult
              .success != null &&
            this.healthPassportData.print_data.api_result.PromiseResult.success
          ">
          <div class="spaces"></div>
          <app-invoicedetails class="notranslate" [data]="this.healthPassportData.print_data.data"
            [dataId]="this.healthPassportData.print_data.showInvoice">
          </app-invoicedetails>
        </div>
      </ng-container>
    </p-dialog>
    <div *ngIf="
        this.healthPassportData.print_data.api_result.PromiseResult.success !=
          null &&
        this.healthPassportData.print_data.api_result.PromiseResult.success
      ">
      <div class="spaces"></div>

      <app-invoicedetails class="notranslate" [data]="this.healthPassportData.print_data.data"
        [dataId]="this.healthPassportData.print_data.printContent">
      </app-invoicedetails>
    </div>
    <div class="ui-g text-center">
      <div class="ui-g-12">
        <img src="assets/images/thank-you/successful.gif" alt="" class="successful-logo" />
      </div>
      <div class="ui-g-12">
        <h2 class="egd-theme-text">
          Thank you for purchasing the Health Passport
        </h2>
        <h3>
          Your capacity to store medical documents has been expanded to 5GB
        </h3>
      </div>
      <div class="ui-g-12">Transaction Successful</div>

      <div class="ui-g-12 transaction-success-buttons">
        <button pButton type="button" class="button-size" style="margin-right: 5px" label="Go to Health Passport"
          (click)="reload()"></button>
        <button pButton type="button" style="margin-right: 5px" class="button-size" label="Navigate to Transactions"
          (click)="RouterNavigation('transactions')"></button>
        <!-- <p-button type="button" [style]="{'margin-right':'5px'}" label="Print Invoice" icon="pi pi-print"
                    (click)="openInvoice()">
                </p-button> -->
      </div>
    </div>
  </p-tabPanel>
</p-tabView>